var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type)?_c('div',[_c('DataInput',{attrs:{"type":"model","name":"vacancyTextTemplate","gql-query":_vm.query,"reduce":function (el) { return el; },"label":_vm.label},on:{"input":_vm.onSelect}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }